module.exports = __webpack_public_path__ + "img/loseblatt1.25d8377d.jpg";